import { settings } from "./settings";

export const log = (l, style = false, force = false) => {
  if (settings.debug || (force && !settings.forceNoLog)) {
    if (style) {
      console.log("%c" + l, style);
    } else {
      console.log(l);
    }
  }
};
